<template>
    <div class="CompanyPay">
        银行卡汇款 手动开通 请联系客服QQ或邮箱
    </div>
</template>

<script>

    export default {
        data() {
            return {
            }
        }
    }
</script>
<style scoped>
    .CompanyPay {
        padding-top: 80px;
    }
</style>